import { Action } from '@ngrx/store';
import {
  DetailPhysicalAddress,
  HttpError,
  SuggestedPhysicalAddress,
} from '@rd/types';

export enum PhysicalAddressActionTypes {
  LOAD_SUGGESTED_ADDRESSES = '[PhysicalAddress] Load SuggestedAddresses',
  LOAD_SUGGESTED_ADDRESSES_SUCCESS = '[PhysicalAddress] Load SuggestedAddresses success',
  LOAD_SUGGESTED_ADDRESSES_FAILED = '[PhysicalAddress] Load SuggestedAddresses failed',
  LOAD_DETAIL_ADDRESS = '[PhysicalAddress] Load DetailAddress',
  LOAD_DETAIL_ADDRESS_SUCCESS = '[PhysicalAddress] Load DetailAddress success',
  LOAD_DETAIL_ADDRESS_FAILED = '[PhysicalAddress] Load DetailAddress failed',
  UPDATE_DETAIL_ADDRESS = '[PhysicalAddress] Update DetailAddress',
}

export class LoadSuggestedAddresses implements Action {
  readonly type = PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES;

  constructor(public payload: { query: string }) {}
}

export class LoadSuggestedAddressesSuccess implements Action {
  readonly type = PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES_SUCCESS;

  constructor(public payload: SuggestedPhysicalAddress[]) {}
}

export class LoadSuggestedAddressesFailed implements Action {
  readonly type = PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES_FAILED;

  constructor(public payload: HttpError) {}
}

export class LoadDetailAddress implements Action {
  readonly type = PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS;

  constructor(public payload: { id: string }) {}
}

export class LoadDetailAddressSuccess implements Action {
  readonly type = PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS_SUCCESS;

  constructor(public payload: DetailPhysicalAddress | null) {}
}

export class LoadDetailAddressFailed implements Action {
  readonly type = PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS_FAILED;

  constructor(public payload: HttpError) {}
}

export class UpdateDetailAddress implements Action {
  readonly type = PhysicalAddressActionTypes.UPDATE_DETAIL_ADDRESS;

  constructor(public payload: DetailPhysicalAddress) {}
}

export type PhysicalAddressActions =
  | UpdateDetailAddress
  | LoadSuggestedAddresses
  | LoadSuggestedAddressesSuccess
  | LoadSuggestedAddressesFailed
  | LoadDetailAddress
  | LoadDetailAddressSuccess
  | LoadDetailAddressFailed;
